import * as _ from "lodash";

import { EAvailabilityMode } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";

declare const window: Window;
const Workspaces = "Workspaces";
const InvestorsWorkspace = "InvestorsWorkspace";
const MarketingWorkspace = "MarketingWorkspace";

const getWorkspacesComponents = (config) => {
    return [Workspaces, InvestorsWorkspace, MarketingWorkspace].reduce((all, name) => {
        return {
            ...all,
            [name]: config[name].resources,
        };
    }, {});
};

const hasPermission = _.curry((config: any, name: string) => {
    return (
        config[Workspaces]?.AvaliabilityMode === EAvailabilityMode.OPEN &&
        config[name]?.AvaliabilityMode === EAvailabilityMode.OPEN
    );
});
const getDefaultConfig = () => getWorkspacesComponents(window.similarweb.settings.components);
// Important notice : we do not want to apply the same permissions to trial user and workspace user
export const hasWorkSpacesPermission = (config = getDefaultConfig()) => hasPermission(config, Workspaces);
export const hasMarketingPermission = (config = getDefaultConfig()) => hasPermission(config, MarketingWorkspace);
export const hasInvestorPermission = (config = getDefaultConfig()) => hasPermission(config, InvestorsWorkspace);

export const getWebSource = (country: number) => {
    // default source is Total
    let webSource = "Total";
    const countryHasMobileWeb = swSettings.allowedCountry(country, "MobileWeb");
    const userHasMobileWeb = swSettings.components.MobileWeb.isAllowed;
    // change to the component default source
    if (!countryHasMobileWeb || !userHasMobileWeb) {
        webSource = swSettings.current.resources.DefaultSource.toString();
    }
    return webSource;
};
